import React from "react";
import { ArrowUp, ArrowUpRight } from "lucide-react";
import { LocalClock } from "./LocalClock";
import { Logo } from "./Logo";
import { links } from "../data/portfolio";
const index = [{
  label: "Work",
  href: "/#work"
}, {
  label: "About",
  href: "/#about"
}, {
  label: "Services",
  href: "/#services"
}, {
  label: "Testimonials",
  href: "/#testimonials"
}, {
  label: "FAQ",
  href: "/#faq"
}, {
  label: "Portfolio",
  href: "/videos"
}];
export function SiteFooter() {
  return <footer className="relative overflow-hidden border-t border-white/10 bg-[#050808] px-5 pb-8 pt-16 text-white md:px-8" data-id="element-378" data-mp="38i1ifdpgj9bb">
      <div className="mx-auto max-w-[1480px]" data-id="element-379" data-mp="33jq5uv7s2kpe">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-380" data-mp="33ki1g61dkifo">
          <div className="lg:col-span-5" data-id="element-381" data-mp="2ykn87vu4ngrg">
            <Logo className="h-8 w-[72px]" data-id="element-382" data-mp="2ylydy174uyl7" />
            <p className="mt-7 font-mono text-[11px] uppercase tracking-[0.2em] text-[#54f6c6]" data-id="element-383" data-mp="11rk0to1cwlk6">End credits</p>
            <p className="mt-6 max-w-sm text-sm leading-7 text-white/65" data-id="element-384" data-mp="wtilne71x6dz">
              Senior 2D &amp; 3D Motion Designer and VFX Artist working across CGI, motion, compositing, and AI-assisted production.
            </p>
            <a href={links.calendly} target="_blank" rel="noreferrer" data-cursor="Book" className="mt-8 inline-flex min-h-11 items-center gap-3 rounded-xl border border-[#54f6c6]/60 px-5 text-sm text-white transition-colors hover:border-[#54f6c6] hover:text-[#54f6c6] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-385" data-mp="1ar9k4t21udii">
              Book a call <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-386" data-mp="1tgpl1hhnc7zg" />
            </a>
          </div>

          <nav aria-label="Footer" className="grid grid-cols-2 gap-8 text-sm lg:col-span-4" data-id="element-387" data-mp="1esbiz8s20njy">
            <div data-id="element-388" data-mp="1jpuy0awkt4cy">
              <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/45" data-id="element-389" data-mp="1jpbptlwq9uc4">Index</p>
              <ul className="mt-2" data-id="element-390" data-mp="27ffiiy8do9oc">
                {index.map(item => <li key={item.label} data-id="element-391" data-mp="2c778p7nmgddy">
                    <a href={item.href} className="flex min-h-11 items-center text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-392" data-mp="2c88mvkzxpfzw">{item.label}</a>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-393" data-mp="2d0epfqx0hhvd">
              <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/45" data-id="element-394" data-mp="2d42iyq2gi4a3">Contact</p>
              <ul className="mt-2" data-id="element-395" data-mp="285hl2xaofwot">
                <li data-id="element-396" data-mp="234blcfiln95s"><a href={links.email} className="flex min-h-11 items-center break-words py-1 text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-397" data-mp="2353kg0benp0t">s.m.zeeshan2233@gmail.com</a></li>
                <li data-id="element-398" data-mp="1tbw4jlj1gqmh"><a href={links.whatsapp} target="_blank" rel="noreferrer" className="flex min-h-11 items-center text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-399" data-mp="1tbw97ytzhest">+973 398 64230</a></li>
                <li data-id="element-400" data-mp="1fezhzw9ydvbe"><a href={links.linkedin} target="_blank" rel="noreferrer" className="flex min-h-11 items-center text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-401" data-mp="1fezgfrub1n9a">LinkedIn</a></li>
              </ul>
            </div>
          </nav>

          <div className="lg:col-span-3 lg:text-right" data-id="element-402" data-mp="4ve4my32xz9l">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/45" data-id="element-403" data-mp="8whkvlp1hxbc">Availability</p>
            <p className="mt-4 text-sm text-white/70" data-id="element-404" data-mp="38ce81lm1dlr0">Booking new projects, worldwide</p>
            <LocalClock className="mt-2 block font-mono text-[11px] uppercase tracking-[0.16em] text-white/45" data-id="element-405" data-mp="3d9ms5rqqvzuw" />
            <a href="#top" className="mt-8 inline-flex min-h-11 items-center gap-2 text-sm uppercase tracking-[0.1em] text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-406" data-mp="3hayjq2t6iv5q">
              Back to top <ArrowUp className="h-4 w-4" aria-hidden="true" data-id="element-407" data-mp="2tmfbfna4qidn" />
            </a>
          </div>
        </div>

        <p aria-hidden="true" className="mt-16 select-none font-heading text-[clamp(2.4rem,9vw,7.5rem)] font-semibold lowercase leading-[0.82] tracking-[-0.06em] text-white/[0.055]" data-id="element-408" data-mp="2ahkanvnllo6v">
          sm zeeshan
        </p>

        {/* Clears the floating pill nav, which sits ~104px off the bottom edge. */}
        <div className="mt-8 flex flex-col gap-3 border-t border-white/10 pb-32 pt-6 font-mono text-[11px] uppercase tracking-[0.14em] text-white/45 sm:flex-row sm:justify-between md:pb-36" data-id="element-409" data-mp="2fh6ni3zil2f5">
          <span data-id="element-410" data-mp="2o98j9oyn1uj3">© {new Date().getFullYear()} SM Zeeshan · All rights reserved</span>
          <span data-id="element-411" data-mp="2obkznxoqzwu1">Motion · CGI · VFX · Post-production</span>
        </div>
      </div>
    </footer>;
}